/* ZAP 2026-07-14 CL-DESHAN: add-only "Got a demand letter?" CTA injected into the Solutions mega-menu.
   DESKTOP: a full-bleed band at the bottom of the Solutions dropdown (alignment CSS-only via
   .znt-mega-cta__inner). MOBILE: a stacked card block at the bottom of the mobile drawer.
   The header structure (header-group.json) + the menu linklist are admin-managed and never touched.
   Remove by deleting this file + its <script> line in layout/theme.liquid + the .znt-mega-cta* CSS. */
(function () {
  if (window.__zntMegaCta) return;
  window.__zntMegaCta = true;

  var CTA = {
    title: 'Got a demand letter?',
    label: 'Get help now',
    href: '/pages/contact-zenyth?subject=demand_letter'       // urgent contact page (De'Shan 2026-07-22)
  };

  function makeTitle() { var t = document.createElement('p'); t.className = 'znt-mega-cta__title'; t.textContent = CTA.title; return t; }
  function makeBtn() { var b = document.createElement('a'); b.className = 'znt-mega-cta__btn'; b.href = CTA.href; b.textContent = CTA.label; return b; }

  // Desktop: full-bleed band with a centered inner box (alignment handled in CSS).
  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'znt-mega-cta';
    var inner = document.createElement('div');
    inner.className = 'znt-mega-cta__inner';
    inner.appendChild(makeTitle());
    inner.appendChild(makeBtn());
    wrap.appendChild(inner);
    return wrap;
  }

  // Desktop Solutions main-nav dropdown(s).
  function targetPanels() {
    var all = document.querySelectorAll('.znt-menu--desktop .znt-featured-menu_list.znt-disclosure_list--dropdown');
    var solutions = [];
    Array.prototype.forEach.call(all, function (panel) {
      var li = panel.closest('.znt-disclosure');
      var btn = li && li.querySelector('.znt-disclosure_button');
      if (btn && /solutions/i.test(btn.textContent)) solutions.push(panel);
    });
    return solutions.length ? solutions : Array.prototype.slice.call(all);
  }

  function injectDesktop() {
    var injected = false;
    targetPanels().forEach(function (panel) {
      if (!panel.querySelector('.znt-mega-cta')) { panel.appendChild(build()); injected = true; }
    });
    return injected;
  }

  // The MAIN mobile drawer list (top level). The CTA now lives in the main menu, NOT nested inside the
  // Solutions submenu (which clipped it and made the drawer scroll sideways). De'Shan 2026-08-06.
  function mobileMainList() {
    var mobile = document.querySelector('.znt-featured-menu_mobile');
    return mobile ? mobile.querySelector('.znt-featured-menu_mobile-panel-list') : null;
  }

  function injectMobile() {
    var list = mobileMainList();
    if (!list || list.querySelector('.znt-mega-cta-li')) return false;
    // Drop the boxed outer container: title + button go straight into a top-level <li> (styled by CSS).
    var li = document.createElement('li');
    li.className = 'znt-mega-cta-li';
    li.appendChild(makeTitle());
    li.appendChild(makeBtn());
    list.appendChild(li);
    return true;
  }

  function inject() { var a = injectDesktop(), b = injectMobile(); return a || b; }

  function done() {
    var dp = targetPanels();
    var desktopOk = dp.length > 0 && dp.every(function (p) { return p.querySelector('.znt-mega-cta'); });
    var mp = mobileMainList();
    var mobileOk = !!(mp && mp.querySelector('.znt-mega-cta-li'));
    return desktopOk && mobileOk;
  }

  // The menu may be built by JS after this defer runs; keep trying until BOTH desktop + mobile exist.
  var tries = 0;
  (function attempt() {
    inject();
    if (done()) return;
    if (++tries < 40) setTimeout(attempt, 100);
  })();

  // Re-inject when a section reloads in the theme editor.
  document.addEventListener('shopify:section:load', inject);
})();
